export enum BTeamDrivesType {
  AdminsOnly = 'AdminsOnly',
  AllUsers = 'AllUsers',
  SelectedUser = 'SelectedUser'
}
